import Wrapper from 'ui-components/Wrapper';
import { useTheme } from '@mui/styles';
import { useMediaQuery } from '@mui/material';
import SIDEBAR_CONFIG from '../../layout/Sidebar/sidebarConfig';
// ==============================|| LOADER ||============================== //
const Loader = () => {
  const theme = useTheme();
  const matchesDownMd = useMediaQuery(theme.breakpoints.down('md'));
  return (
    // <Modal open={true}>
    <Wrapper className="skeleton" sx={{
      display: 'grid',
      height: '100dvh',
      width: {xs: "100vw", md : "100vw"},
      placeItems: 'center',
      position: 'fixed',
      top: {xs: "0px", md: "20px"},
      left:  {xs: "0rem", md: `${SIDEBAR_CONFIG.desktop.expanded}px`},
      right: 0,
      bottom: 0,
      borderRadius:  {xs: "0px 0px 0px !important", md: "24px 0px 0px !important"}
    }}>
      {/* <CircularProgress sx={{ color: theme?.palette.customColors.b300 }} /> */}
    </Wrapper>
    // </Modal>
  )
};

export default Loader;